import React, { useEffect, useRef } from 'react'; // Import useRef
import BurgerMenu from "./components/burgermenu";
import Hero from './components/hero';
import CategoriesComponent from './components/categories'; // Renamed to avoid conflict
import FeaturedPosts from './components/featuredposts';
import FAQ from './components/faq';
import Footer from './components/footer';
import Newsletter from './components/newsletter';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import CategoryPage from './components/categorypage';
import ArticlePage from './components/ArticlePage'; // Added import for ArticlePage
import CategoriesPage from './pages/categoriespage'; // Import the Categories page
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import 'aos/dist/aos.css'; // Import AOS styles
import AOS from 'aos';
import { initAffiliateClickTracking } from './lib/analytics';

// Import Amplitude scripts
const loadAmplitude = () => {
    // Load analytics script
    const analyticsScript = document.createElement('script');
    analyticsScript.src = 'https://cdn.amplitude.com/libs/analytics-browser-2.11.1-min.js.gz';
    analyticsScript.async = true;
    document.head.appendChild(analyticsScript);

    // Load session replay plugin
    const replayScript = document.createElement('script');
    replayScript.src = 'https://cdn.amplitude.com/libs/plugin-session-replay-browser-1.8.0-min.js.gz';
    replayScript.async = true;
    document.head.appendChild(replayScript);

    // Initialize Amplitude after scripts are loaded
    replayScript.onload = () => {
        window.amplitude.add(window.sessionReplay.plugin({sampleRate: 1}));
        window.amplitude.init('5961d2717db7141fe4a558e8ca965392', {
            serverZone: "EU",
            autocapture: {elementInteractions: true}
        });
    };
};

function App() {
    useEffect(() => {
        AOS.init({
            duration: 800, // Animation duration in milliseconds
            easing: 'ease-in-out', // Easing for the animations
            once: true, // Only animate once when in view
        });
        AOS.refresh(); // Reinitialize AOS to ensure elements are detected
        loadAmplitude();
        initAffiliateClickTracking();
    }, []);

    const categoriesRef = useRef(null); // Add reference for the Categories section

    return (
        <Router>
            <BurgerMenu />
            <Routes>
                {/* Homepage Route */}
                <Route
                    path="/"
                    element={
                        <div className="App">
                            <Hero scrollToCategories={() => categoriesRef.current.scrollIntoView({ behavior: 'smooth' })} />
                            <CategoriesComponent ref={categoriesRef} />
                            <FeaturedPosts />
                            <Newsletter />
                            <FAQ />
                            <Footer />
                        </div>
                    }
                />

                {/* Category Page Route */}
                <Route path="/category/:categoryName" element={<CategoryPage />} />

                {/* Article Page Route */}
                <Route path="/article/:articleSlug" element={<ArticlePage />} />

                {/* Categories Page Route */}
                <Route path="/categories" element={<CategoriesPage />} />

                {/* Contact Page Route */}
                <Route path="/contact" element={<ContactPage />} />

                {/* Admin Route */}
                <Route path="/admin" element={<AdminPage />} />
            </Routes>
        </Router>
    );
}

export default App;
